import React, { useEffect, useState } from "react";
import "assets/scss/pages/DesignSystem.scss";
import "./PreviewPage.scss";
import PrimaryButton from "components/Common/PrimaryButton";
import Inputs from "components/Inputs";
import { ButtonIcon } from "components/Icons";
import Textarea from "components/Textarea";
import Tabs from "components/Tabs";
import RadioComponent from "components/Common/RadioComponent";
import CheckboxComponent from "components/Common/CheckboxComponent";
import ToggleComponent from "components/Common/ToggleComponent";
// import { useGlobalContext } from "../../context/GlobalContext";
import { useNavigate } from "react-router-dom";
import ThemeToggle from "components/Common/ThemeToggle";

const PreviewPage = () => {
  const navigate = useNavigate();

  const goHome = () => {
    navigate("/");
  };

  return (
    <div className="preview-page ">
      <header>
        <div className="container">
          <div className="menu-top d-flex justify-content-between dis-mb-32">
            <div className="logo" onClick={goHome}></div>
            <nav className="desktop">
              <ul>
                <li>
                  <PrimaryButton
                    text="About"
                    // className="dss-btn dss-btn-link dss-btn-md plt-heading-xs"
                    variant="link"
                    size="md"
                    className="plt-heading-xs"
                  />
                </li>
                <li>
                  <PrimaryButton
                    text="Services"
                    // className="dss-btn dss-btn-link dss-btn-md plt-heading-xs"
                    variant="link"
                    size="md"
                    className="plt-heading-xs"
                  />
                </li>
                <li className="btn-nav">
                  <PrimaryButton
                    text="Contact"
                    // className="dss-btn dss-btn-outlined dss-btn-md"
                    variant="outlined"
                    size="md"
                  />
                </li>
              </ul>
            </nav>
            <nav className="mobile">
              <h3>
                <i className="fa-solid fa-bars"></i>
              </h3>
              <ul>
                <li>
                  <PrimaryButton
                    text="About"
                    // className="dss-btn dss-btn-link dss-btn-md plt-heading-xs"
                    variant="link"
                    size="md"
                    className="plt-heading-xs"
                  />
                </li>
                <li>
                  <PrimaryButton
                    text="Services"
                    // className="dss-btn dss-btn-link dss-btn-md plt-heading-xs"
                    variant="link"
                    size="md"
                    className="plt-heading-xs"
                  />
                </li>
                <li className="btn-nav">
                  <PrimaryButton
                    text="Contact"
                    // className="dss-btn dss-btn-outlined dss-btn-md"
                    variant="outlined"
                    size="md"
                  />
                </li>
              </ul>
            </nav>
            <div className="flex-fit">
              <ThemeToggle></ThemeToggle>
            </div>
          </div>
          <div className="preview-banner d-flex justify-content-between">
            <div className="call-header">
              <h2 className="plt-heading-3xl plt-font-color-light">
                You sell more with web automation
              </h2>
              <p className="plt-heading-xs plt-font-color-light dis-mt-10">
                We create marketing solutions for your company to sell more, in
                the best way
              </p>
            </div>
            <div className="banner-tab">
              <Tabs
                dataItem={[
                  {
                    key: 1,
                    label: "Sign in",
                    content: (
                      <div>
                        <h3 className="plt-heading-xs plt-font-color-primary dis-mb-16">
                          Log in
                        </h3>
                        <div className="banner-form">
                          <form action="#">
                            <Inputs
                              className="dis-mb-12"
                              leadingIcon={false}
                              tailingIcon={true}
                              prefix={false}
                              suffix={false}
                              tag={false}
                              readOnlyState={false}
                              disabled={false}
                              label="Username"
                              placeholder="Username"
                            />
                            <Inputs
                              className="dis-mb-12"
                              leadingIcon={false}
                              tailingIcon={true}
                              prefix={false}
                              suffix={false}
                              tag={false}
                              readOnlyState={false}
                              disabled={false}
                              label="Password"
                              placeholder="Password"
                            />
                            <ToggleComponent
                              className="dis-mb-16"
                              size="large"
                              hasLabel={true}
                              toggletext="Keep me signed in"
                              token="large"
                              disabled={false}
                            />
                            <PrimaryButton
                              text="Sign in"
                              // className="dss-btn dss-btn-primary dss-btn-md"
                              variant="primary"
                              size="md"
                            />
                          </form>
                        </div>
                      </div>
                    ),
                  },
                  {
                    key: 2,
                    label: "Sign up",
                    content: (
                      <div>
                        <h3 className="plt-heading-xs plt-font-color-primary dis-mb-16">
                          Sign up
                        </h3>
                        <div className="banner-form">
                          <form action="#">
                            <Inputs
                              className="dis-mb-12"
                              leadingIcon={false}
                              tailingIcon={false}
                              prefix={false}
                              suffix={false}
                              tag={false}
                              readOnlyState={false}
                              disabled={false}
                              label="Name"
                              placeholder="Name"
                            />
                            <Inputs
                              className="dis-mb-12"
                              leadingIcon={false}
                              tailingIcon={false}
                              prefix={false}
                              suffix={false}
                              tag={false}
                              readOnlyState={false}
                              disabled={false}
                              label="Email"
                              placeholder="Email"
                            />
                            <Inputs
                              className="dis-mb-12"
                              leadingIcon={false}
                              tailingIcon={false}
                              prefix={false}
                              suffix={false}
                              tag={false}
                              readOnlyState={false}
                              disabled={false}
                              label="Password"
                              placeholder="Password"
                            />
                            <Inputs
                              className="dis-mb-12"
                              leadingIcon={false}
                              tailingIcon={false}
                              prefix={false}
                              suffix={false}
                              tag={false}
                              readOnlyState={false}
                              disabled={false}
                              label="Confirm Password"
                              placeholder="Confirm Password"
                            />
                            <h3 className="plt-heading-xs plt-font-color-primary dis-mb-16">
                              What kind of item would you like to add?
                            </h3>
                            <RadioComponent
                              className="dis-mb-12"
                              size="md"
                              hasLabel={true}
                              options={[
                                { value: "option1", label: "Service" },
                                { value: "option2", label: "Product" },
                              ]}
                              checkedValue="option1"
                              variant="default"
                              disabled={false}
                            />
                            <Textarea
                              className="dis-mb-16"
                              validation={false}
                              tag={false}
                              disabled={false}
                              readOnlyState={false}
                              label="Any comments or suggestions?"
                              placeholder="Comments"
                            />
                            <CheckboxComponent
                              className="dis-mb-16"
                              label="I read and agree to terms & conditions"
                              size="normal"
                              variant="outline"
                              value={true}
                            />
                            <PrimaryButton
                              text="Sign up"
                              // className="dss-btn dss-btn-primary dss-btn-md"
                              variant="primary"
                              size="md"
                            />
                          </form>
                        </div>
                      </div>
                    ),
                  },
                ]}
                variant="someVariant"
              />
            </div>
          </div>
        </div>
      </header>

      <div className="description">
        <div className="container">
          <p className="plt-body-lg">
            With years of experience in web development and marketing
            automation, Design system brings solutions that help your team sell
            more in both B2C and B2B segments.
          </p>
          <div className="d-flex justify-content-center">
            <form action="#" className="header-form d-flex">
              <div className="header-input">
                <Inputs
                  leadingIcon={false}
                  tailingIcon={false}
                  prefix={false}
                  suffix={false}
                  tag={false}
                  readOnlyState={false}
                  disabled={false}
                  fluid={true}
                  label="your mail"
                />
              </div>
              <PrimaryButton
                text="know more"
                // className="dss-btn dss-btn-primary dss-btn-md"
                variant="primary"
                size="md"
              />
            </form>
          </div>
        </div>
      </div>

      <div className="info">
        <div className="container">
          <div className="info-sub d-flex justify-content-between">
            <div className="text-info">
              <h3 className="plt-heading-md  font-color-primary">
                We are a digital agency. We work on its positioning, content and
                aesthetics, always focused on conversion.
              </h3>
              <p className="plt-body-md">
                At our digital agency, we're more than pixel pushers—we're
                strategists, storytellers, and conversion professionals. We
                dissect your brand, audience, and market. Then, armed with
                insights, we position you for digital victory.
              </p>
            </div>

            <img
              src="https://i.postimg.cc/C5p1893x/mockup1.jpg"
              alt="Imagem de chamada"
            />
          </div>
        </div>
      </div>

      <div className="services">
        <div className="container">
          <div className="title-services">
            <h3 className="plt-heading-lg plt-font-color-secondary">
              How can we help your company
            </h3>
          </div>

          <div className="flex-services">
            <div className="space-services">
              <div className="box-services">
                <img
                  src="https://i.postimg.cc/yx2wWztL/img3.jpg"
                  alt="Email Marketing"
                />
                <div className="wrapper-services">
                  <h2>Email Marketing</h2>
                  <p>
                    Learn how to use email marketing in your company to boost
                    your sales in an automated way.
                  </p>
                  <PrimaryButton
                    text="Budget"
                    // className="dss-btn dss-btn-ghost dss-btn-lg"
                    variant="ghost"
                    size="lg"
                  />
                </div>
              </div>
            </div>

            <div className="space-services">
              <div className="box-services">
                <img
                  src="https://i.postimg.cc/50Kcdz3d/img1.jpg"
                  alt="Sales Page"
                />
                <div className="wrapper-services">
                  <h2>Sales Page</h2>
                  <p>
                    We create 100% optimized, conversion-oriented sales pages.
                    Request a quote and have your page to sell on the internet
                    today.
                  </p>
                  <PrimaryButton
                    text="Budget"
                    // className="dss-btn dss-btn-ghost dss-btn-lg"
                    variant="ghost"
                    size="lg"
                  />
                </div>
              </div>
            </div>

            <div className="space-services">
              <div className="box-services">
                <img
                  src="https://i.postimg.cc/wM1C6Bft/img2.jpg"
                  alt="Capture Pages"
                />
                <div className="wrapper-services">
                  <h2>Capture and Signup Pages</h2>
                  <p>
                    Capture visitors' email addresses on your website and create
                    a lead base for your company.
                  </p>
                  <PrimaryButton
                    text="Budget"
                    // className="dss-btn dss-btn-ghost dss-btn-lg"
                    variant="ghost"
                    size="lg"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section>
        <div className="container">
          <h2>TRIAL</h2>
          <div class="dss-alert dss-alert-informative w-100">
            <div class="dss-alert-contents-wrapper">
              <div class="dss-alert-contents-info">
                <div class="dss-alert-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    color="#171717"
                  >
                    <rect
                      x="4.75"
                      y="4.75"
                      width="14.3581"
                      height="14.3581"
                      stroke="#171717"
                      stroke-width="1.5"
                    ></rect>
                    <path
                      d="M5.5 5.5L18.3615 18.3615"
                      stroke="#171717"
                      stroke-width="1.5"
                    ></path>
                    <path
                      d="M18.3563 5.5L5.5 18.3563"
                      stroke="#171717"
                      stroke-width="1.5"
                    ></path>
                  </svg>
                </div>
                <div class="dss-alert-msg-container dss-alert-action-footer">
                  <h6 class="dss-alert-msg">Informative</h6>
                  <p class="dss-alert-desc">
                    This is an info alert. It also has longer text to see what
                    these alerts can look like when broken into multiple lines.
                    This one will definitely break into multiple lines in most
                    standard screen resolutions.
                  </p>
                </div>
              </div>
              <div class="d-flex dss-alert-btn-group">
                <button
                  class="dss-btn dss-btn-primary dss-btn-sm     "
                  type="button"
                >
                  button{" "}
                </button>
                <button
                  class="dss-btn dss-btn-outlined dss-btn-sm     "
                  type="button"
                >
                  button{" "}
                </button>
              </div>
            </div>
            <span class="dss-alert-close-icon">
              <svg
                width="8"
                height="8"
                viewBox="0 0 8 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.66484 1.33667L1.33855 6.6612"
                  stroke="#434343"
                  stroke-width="1.5"
                  stroke-linecap="round"
                ></path>
                <path
                  d="M6.66666 6.66671L1.33333 1.33337"
                  stroke="#434343"
                  stroke-width="1.5"
                  stroke-linecap="round"
                ></path>
              </svg>
            </span>
          </div>
          {/* ALERT */}
          <div class="dss-alert dss-alert-caution w-100">
            <div class="dss-alert-contents-wrapper">
              <div class="dss-alert-contents-info">
                <div class="dss-alert-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    color="#171717"
                  >
                    <rect
                      x="4.75"
                      y="4.75"
                      width="14.3581"
                      height="14.3581"
                      stroke="#171717"
                      stroke-width="1.5"
                    ></rect>
                    <path
                      d="M5.5 5.5L18.3615 18.3615"
                      stroke="#171717"
                      stroke-width="1.5"
                    ></path>
                    <path
                      d="M18.3563 5.5L5.5 18.3563"
                      stroke="#171717"
                      stroke-width="1.5"
                    ></path>
                  </svg>
                </div>
                <div class="dss-alert-msg-container dss-alert-action-footer">
                  <h6 class="dss-alert-msg">Informative</h6>
                  <p class="dss-alert-desc">
                    This is an info alert. It also has longer text to see what
                    these alerts can look like when broken into multiple lines.
                    This one will definitely break into multiple lines in most
                    standard screen resolutions.
                  </p>
                </div>
              </div>
              <div class="d-flex dss-alert-btn-group">
                <button
                  class="dss-btn dss-btn-primary dss-btn-sm     "
                  type="button"
                >
                  button{" "}
                </button>
                <button
                  class="dss-btn dss-btn-outlined dss-btn-sm     "
                  type="button"
                >
                  button{" "}
                </button>
              </div>
            </div>
            <span class="dss-alert-close-icon">
              <svg
                width="8"
                height="8"
                viewBox="0 0 8 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.66484 1.33667L1.33855 6.6612"
                  stroke="#434343"
                  stroke-width="1.5"
                  stroke-linecap="round"
                ></path>
                <path
                  d="M6.66666 6.66671L1.33333 1.33337"
                  stroke="#434343"
                  stroke-width="1.5"
                  stroke-linecap="round"
                ></path>
              </svg>
            </span>
          </div>
          {/* ALERT */}
          <div class="dss-alert dss-alert-success w-100">
            <div class="dss-alert-contents-wrapper">
              <div class="dss-alert-contents-info">
                <div class="dss-alert-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    color="#171717"
                  >
                    <rect
                      x="4.75"
                      y="4.75"
                      width="14.3581"
                      height="14.3581"
                      stroke="#171717"
                      stroke-width="1.5"
                    ></rect>
                    <path
                      d="M5.5 5.5L18.3615 18.3615"
                      stroke="#171717"
                      stroke-width="1.5"
                    ></path>
                    <path
                      d="M18.3563 5.5L5.5 18.3563"
                      stroke="#171717"
                      stroke-width="1.5"
                    ></path>
                  </svg>
                </div>
                <div class="dss-alert-msg-container dss-alert-action-footer">
                  <h6 class="dss-alert-msg">Informative</h6>
                  <p class="dss-alert-desc">
                    This is an info alert. It also has longer text to see what
                    these alerts can look like when broken into multiple lines.
                    This one will definitely break into multiple lines in most
                    standard screen resolutions.
                  </p>
                </div>
              </div>
              <div class="d-flex dss-alert-btn-group">
                <button
                  class="dss-btn dss-btn-primary dss-btn-sm     "
                  type="button"
                >
                  button{" "}
                </button>
                <button
                  class="dss-btn dss-btn-outlined dss-btn-sm     "
                  type="button"
                >
                  button{" "}
                </button>
              </div>
            </div>
            <span class="dss-alert-close-icon">
              <svg
                width="8"
                height="8"
                viewBox="0 0 8 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.66484 1.33667L1.33855 6.6612"
                  stroke="#434343"
                  stroke-width="1.5"
                  stroke-linecap="round"
                ></path>
                <path
                  d="M6.66666 6.66671L1.33333 1.33337"
                  stroke="#434343"
                  stroke-width="1.5"
                  stroke-linecap="round"
                ></path>
              </svg>
            </span>
          </div>
          {/* ALERT */}
          <div class="dss-alert dss-alert-danger w-100">
            <div class="dss-alert-contents-wrapper">
              <div class="dss-alert-contents-info">
                <div class="dss-alert-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    color="#171717"
                  >
                    <rect
                      x="4.75"
                      y="4.75"
                      width="14.3581"
                      height="14.3581"
                      stroke="#171717"
                      stroke-width="1.5"
                    ></rect>
                    <path
                      d="M5.5 5.5L18.3615 18.3615"
                      stroke="#171717"
                      stroke-width="1.5"
                    ></path>
                    <path
                      d="M18.3563 5.5L5.5 18.3563"
                      stroke="#171717"
                      stroke-width="1.5"
                    ></path>
                  </svg>
                </div>
                <div class="dss-alert-msg-container dss-alert-action-footer">
                  <h6 class="dss-alert-msg">Informative</h6>
                  <p class="dss-alert-desc">
                    This is an info alert. It also has longer text to see what
                    these alerts can look like when broken into multiple lines.
                    This one will definitely break into multiple lines in most
                    standard screen resolutions.
                  </p>
                </div>
              </div>
              <div class="d-flex dss-alert-btn-group">
                <button
                  class="dss-btn dss-btn-primary dss-btn-sm     "
                  type="button"
                >
                  button{" "}
                </button>
                <button
                  class="dss-btn dss-btn-outlined dss-btn-sm     "
                  type="button"
                >
                  button{" "}
                </button>
              </div>
            </div>
            <span class="dss-alert-close-icon">
              <svg
                width="8"
                height="8"
                viewBox="0 0 8 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.66484 1.33667L1.33855 6.6612"
                  stroke="#434343"
                  stroke-width="1.5"
                  stroke-linecap="round"
                ></path>
                <path
                  d="M6.66666 6.66671L1.33333 1.33337"
                  stroke="#434343"
                  stroke-width="1.5"
                  stroke-linecap="round"
                ></path>
              </svg>
            </span>
          </div>
          {/* AVATAR */}
          <div class="avatar-badge">
            <div class="avatar avatar-circle avatar-xl default ">
              <img
                src="/static/media/avatar.3099a42850710725aa17.png "
                alt="avatar "
                class="avatar-image "
              />
            </div>
          </div>
          {/* AVATAR */}
          <div class="avatar-badge">
            <div class="avatar avatar-circle avatar-xl default ">
              <img
                src="/static/media/avatar.3099a42850710725aa17.png "
                alt="avatar "
                class="avatar-image "
              />
            </div>
            <span class="avatar-status ">
              <svg
                width="11 "
                height="8 "
                viewBox="0 0 11 8 "
                fill="none "
                xmlns="http://www.w3.org/2000/svg "
              >
                <path
                  d="M1 3.75L3.83413 6.5L9.5 1 "
                  stroke="white "
                  stroke-width="1.5
			"
                  stroke-linecap="round "
                  stroke-linejoin="round "
                ></path>
              </svg>
            </span>
          </div>
          {/* AVATAR */}
          <div class="avatar-badge">
            <div class="avatar avatar-circle avatar-xl default ">
              <img
                src="/static/media/avatar.3099a42850710725aa17.png "
                alt="avatar "
                class="avatar-image "
              />
            </div>
            <span class="avatar-active "></span>
          </div>
          {/* AVATAR */}
          <div class="avatar-badge">
            <div class="avatar avatar-circle avatar-xl silhouette">
              <svg
                width="48"
                height="60"
                viewBox="0 0 48 60"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M39.882 15.8732C39.882 24.6842 32.8173 31.7493 24 31.7493C15.1857 31.7493 8.11804 24.6842 8.11804 15.8732C8.11804 7.06207 15.1857 0 24 0C32.8173 0 39.882 7.06207 39.882 15.8732ZM24 60C10.9871 60 0 57.885 0 49.7249C0 41.5618 11.0561 39.5218 24 39.5218C37.0159 39.5218 48 41.6368 48 49.7969C48 57.96 36.9439 60 24 60Z"
                  fill="white"
                ></path>
              </svg>
            </div>
          </div>
          <div class="avatar-badge">
            <div class="avatar avatar-circle avatar-xl silhouette">
              <svg
                width="48"
                height="60"
                viewBox="0 0 48 60"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M39.882 15.8732C39.882 24.6842 32.8173 31.7493 24 31.7493C15.1857 31.7493 8.11804 24.6842 8.11804 15.8732C8.11804 7.06207 15.1857 0 24 0C32.8173 0 39.882 7.06207 39.882 15.8732ZM24 60C10.9871 60 0 57.885 0 49.7249C0 41.5618 11.0561 39.5218 24 39.5218C37.0159 39.5218 48 41.6368 48 49.7969C48 57.96 36.9439 60 24 60Z"
                  fill="white"
                ></path>
              </svg>
            </div>
            <span class="avatar-status">
              <svg
                width="11"
                height="8"
                viewBox="0 0 11 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 3.75L3.83413 6.5L9.5 1"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </span>
          </div>
          <div class="avatar-badge">
            <div class="avatar avatar-circle avatar-xl silhouette">
              <svg
                width="48"
                height="60"
                viewBox="0 0 48 60"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M39.882 15.8732C39.882 24.6842 32.8173 31.7493 24 31.7493C15.1857 31.7493 8.11804 24.6842 8.11804 15.8732C8.11804 7.06207 15.1857 0 24 0C32.8173 0 39.882 7.06207 39.882 15.8732ZM24 60C10.9871 60 0 57.885 0 49.7249C0 41.5618 11.0561 39.5218 24 39.5218C37.0159 39.5218 48 41.6368 48 49.7969C48 57.96 36.9439 60 24 60Z"
                  fill="white"
                ></path>
              </svg>
            </div>
            <span class="avatar-active"></span>
          </div>
          {/* AVATAR */}
          <div class="avatar-badge">
            <div class="avatar avatar-circle avatar-xl textonly">
              <div class="avatar-text">AA</div>
            </div>
          </div>
          {/* AVATAR */}
          <div class="avatar-badge">
            <div class="avatar avatar-circle avatar-xl textonly">
              <div class="avatar-text">AA</div>
            </div>
            <span class="avatar-status">
              <svg
                width="11"
                height="8"
                viewBox="0 0 11 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 3.75L3.83413 6.5L9.5 1"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </span>
          </div>
          {/* AVATAR */}
          <div class="avatar-badge">
            <div class="avatar avatar-circle avatar-xl textonly">
              <div class="avatar-text">AA</div>
            </div>
            <span class="avatar-active"></span>
          </div>
          {/* AVATAR-sizes */}
          <div class="component-area-ui d-flex justify-content-center dis-column-gap-12 dis-row-gap-12">
            <div class="avatar-badge">
              <div class="avatar avatar-circle avatar-xxl default">
                <img
                  src="/static/media/avatar.3099a42850710725aa17.png"
                  alt="avatar"
                  class="avatar-image"
                />
              </div>
            </div>
            <div class="avatar-badge">
              <div class="avatar avatar-circle avatar-xxl silhouette">
                <svg
                  width="48"
                  height="60"
                  viewBox="0 0 48 60"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M39.882 15.8732C39.882 24.6842 32.8173 31.7493 24 31.7493C15.1857 31.7493 8.11804 24.6842 8.11804 15.8732C8.11804 7.06207 15.1857 0 24 0C32.8173 0 39.882 7.06207 39.882 15.8732ZM24 60C10.9871 60 0 57.885 0 49.7249C0 41.5618 11.0561 39.5218 24 39.5218C37.0159 39.5218 48 41.6368 48 49.7969C48 57.96 36.9439 60 24 60Z"
                    fill="white"
                  ></path>
                </svg>
              </div>
            </div>
            <div class="avatar-badge">
              <div class="avatar avatar-circle avatar-xxl textonly">
                <div class="avatar-text">AA</div>
              </div>
            </div>
          </div>
          {/* AVATAR-sizes */}
          <div class="component-area-ui d-flex justify-content-center dis-column-gap-12 dis-row-gap-12">
            <div class="avatar-badge">
              <div class="avatar avatar-circle avatar-xl default">
                <img
                  src="/static/media/avatar.3099a42850710725aa17.png"
                  alt="avatar"
                  class="avatar-image"
                />
              </div>
            </div>
            <div class="avatar-badge">
              <div class="avatar avatar-circle avatar-xl silhouette">
                <svg
                  width="48"
                  height="60"
                  viewBox="0 0 48 60"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M39.882 15.8732C39.882 24.6842 32.8173 31.7493 24 31.7493C15.1857 31.7493 8.11804 24.6842 8.11804 15.8732C8.11804 7.06207 15.1857 0 24 0C32.8173 0 39.882 7.06207 39.882 15.8732ZM24 60C10.9871 60 0 57.885 0 49.7249C0 41.5618 11.0561 39.5218 24 39.5218C37.0159 39.5218 48 41.6368 48 49.7969C48 57.96 36.9439 60 24 60Z"
                    fill="white"
                  ></path>
                </svg>
              </div>
            </div>
            <div class="avatar-badge">
              <div class="avatar avatar-circle avatar-xl textonly">
                <div class="avatar-text">AA</div>
              </div>
            </div>
          </div>
          {/* AVATAR-sizes */}
          <div class="component-area-ui d-flex justify-content-center dis-column-gap-12 dis-row-gap-12">
            <div class="avatar-badge">
              <div class="avatar avatar-circle avatar-lg default">
                <img
                  src="/static/media/avatar.3099a42850710725aa17.png"
                  alt="avatar"
                  class="avatar-image"
                />
              </div>
            </div>
            <div class="avatar-badge">
              <div class="avatar avatar-circle avatar-lg silhouette">
                <svg
                  width="48"
                  height="60"
                  viewBox="0 0 48 60"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M39.882 15.8732C39.882 24.6842 32.8173 31.7493 24 31.7493C15.1857 31.7493 8.11804 24.6842 8.11804 15.8732C8.11804 7.06207 15.1857 0 24 0C32.8173 0 39.882 7.06207 39.882 15.8732ZM24 60C10.9871 60 0 57.885 0 49.7249C0 41.5618 11.0561 39.5218 24 39.5218C37.0159 39.5218 48 41.6368 48 49.7969C48 57.96 36.9439 60 24 60Z"
                    fill="white"
                  ></path>
                </svg>
              </div>
            </div>
            <div class="avatar-badge">
              <div class="avatar avatar-circle avatar-lg textonly">
                <div class="avatar-text">AA</div>
              </div>
            </div>
          </div>
          {/* AVATAR-sizes */}
          <div class="component-area-ui d-flex justify-content-center dis-column-gap-12 dis-row-gap-12">
            <div class="avatar-badge">
              <div class="avatar avatar-circle avatar-undefined default">
                <img
                  src="/static/media/avatar.3099a42850710725aa17.png"
                  alt="avatar"
                  class="avatar-image"
                />
              </div>
            </div>
            <div class="avatar-badge">
              <div class="avatar avatar-circle avatar-undefined silhouette">
                <svg
                  width="48"
                  height="60"
                  viewBox="0 0 48 60"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M39.882 15.8732C39.882 24.6842 32.8173 31.7493 24 31.7493C15.1857 31.7493 8.11804 24.6842 8.11804 15.8732C8.11804 7.06207 15.1857 0 24 0C32.8173 0 39.882 7.06207 39.882 15.8732ZM24 60C10.9871 60 0 57.885 0 49.7249C0 41.5618 11.0561 39.5218 24 39.5218C37.0159 39.5218 48 41.6368 48 49.7969C48 57.96 36.9439 60 24 60Z"
                    fill="white"
                  ></path>
                </svg>
              </div>
            </div>
            <div class="avatar-badge">
              <div class="avatar avatar-circle avatar-undefined textonly">
                <div class="avatar-text">AA</div>
              </div>
            </div>
          </div>
          {/* AVATAR-sizes */}
          <div class="component-area-ui d-flex justify-content-center dis-column-gap-12 dis-row-gap-12">
            <div class="avatar-badge">
              <div class="avatar avatar-circle avatar-sm default">
                <img
                  src="/static/media/avatar.3099a42850710725aa17.png"
                  alt="avatar"
                  class="avatar-image"
                />
              </div>
            </div>
            <div class="avatar-badge">
              <div class="avatar avatar-circle avatar-sm silhouette">
                <svg
                  width="48"
                  height="60"
                  viewBox="0 0 48 60"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M39.882 15.8732C39.882 24.6842 32.8173 31.7493 24 31.7493C15.1857 31.7493 8.11804 24.6842 8.11804 15.8732C8.11804 7.06207 15.1857 0 24 0C32.8173 0 39.882 7.06207 39.882 15.8732ZM24 60C10.9871 60 0 57.885 0 49.7249C0 41.5618 11.0561 39.5218 24 39.5218C37.0159 39.5218 48 41.6368 48 49.7969C48 57.96 36.9439 60 24 60Z"
                    fill="white"
                  ></path>
                </svg>
              </div>
            </div>
            <div class="avatar-badge">
              <div class="avatar avatar-circle avatar-sm textonly">
                <div class="avatar-text">AA</div>
              </div>
            </div>
          </div>
          {/* AVATAR-sizes */}
          <div class="component-area-ui d-flex justify-content-center dis-column-gap-12 dis-row-gap-12">
            <div class="avatar-badge">
              <div class="avatar avatar-circle avatar-xs default">
                <img
                  src="/static/media/avatar.3099a42850710725aa17.png"
                  alt="avatar"
                  class="avatar-image"
                />
              </div>
            </div>
            <div class="avatar-badge">
              <div class="avatar avatar-circle avatar-xs silhouette">
                <svg
                  width="48"
                  height="60"
                  viewBox="0 0 48 60"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M39.882 15.8732C39.882 24.6842 32.8173 31.7493 24 31.7493C15.1857 31.7493 8.11804 24.6842 8.11804 15.8732C8.11804 7.06207 15.1857 0 24 0C32.8173 0 39.882 7.06207 39.882 15.8732ZM24 60C10.9871 60 0 57.885 0 49.7249C0 41.5618 11.0561 39.5218 24 39.5218C37.0159 39.5218 48 41.6368 48 49.7969C48 57.96 36.9439 60 24 60Z"
                    fill="white"
                  ></path>
                </svg>
              </div>
            </div>
            <div class="avatar-badge">
              <div class="avatar avatar-circle avatar-xs textonly">
                <div class="avatar-text">AA</div>
              </div>
            </div>
          </div>
          {/* AVATAR-GROUP */}
          <div class="avatar-group">
            <div class="avatar avatar-circle avatar-lg dafault avatar-group-count">
              3+
            </div>
            <div class="avatar avatar-circle avatar-lg dafault">
              <img
                src="/static/media/avatar.3099a42850710725aa17.png"
                alt="avatar"
                class="avatar-image"
              />
            </div>
            <div class="avatar avatar-circle avatar-lg dafault">
              <img
                src="/static/media/avatar.3099a42850710725aa17.png"
                alt="avatar"
                class="avatar-image"
              />
            </div>
            <div class="avatar avatar-circle avatar-lg dafault">
              <img
                src="/static/media/avatar.3099a42850710725aa17.png"
                alt="avatar"
                class="avatar-image"
              />
            </div>
            <div class="avatar avatar-circle avatar-lg dafault">
              <img
                src="/static/media/avatar.3099a42850710725aa17.png"
                alt="avatar"
                class="avatar-image"
              />
            </div>
          </div>
          {/* AVATAR-GROUP */}
          <div class="avatar-group">
            <div class="avatar avatar-circle avatar-md dafault avatar-group-count">
              3+
            </div>
            <div class="avatar avatar-circle avatar-md dafault">
              <img
                src="/static/media/avatar.3099a42850710725aa17.png"
                alt="avatar"
                class="avatar-image"
              />
            </div>
            <div class="avatar avatar-circle avatar-md dafault">
              <img
                src="/static/media/avatar.3099a42850710725aa17.png"
                alt="avatar"
                class="avatar-image"
              />
            </div>
            <div class="avatar avatar-circle avatar-md dafault">
              <img
                src="/static/media/avatar.3099a42850710725aa17.png"
                alt="avatar"
                class="avatar-image"
              />
            </div>
            <div class="avatar avatar-circle avatar-md dafault">
              <img
                src="/static/media/avatar.3099a42850710725aa17.png"
                alt="avatar"
                class="avatar-image"
              />
            </div>
          </div>
          {/* AVATAR-GROUP */}
          <div class="avatar-group">
            <div class="avatar avatar-circle avatar-sm dafault avatar-group-count">
              3+
            </div>
            <div class="avatar avatar-circle avatar-sm dafault">
              <img
                src="/static/media/avatar.3099a42850710725aa17.png"
                alt="avatar"
                class="avatar-image"
              />
            </div>
            <div class="avatar avatar-circle avatar-sm dafault">
              <img
                src="/static/media/avatar.3099a42850710725aa17.png"
                alt="avatar"
                class="avatar-image"
              />
            </div>
            <div class="avatar avatar-circle avatar-sm dafault">
              <img
                src="/static/media/avatar.3099a42850710725aa17.png"
                alt="avatar"
                class="avatar-image"
              />
            </div>
            <div class="avatar avatar-circle avatar-sm dafault">
              <img
                src="/static/media/avatar.3099a42850710725aa17.png"
                alt="avatar"
                class="avatar-image"
              />
            </div>
          </div>

          {/* checkbox */}
          <div class="dss-custom-checkbox  ">
            <div class="dss-checkbox-wrapper">
              <input
                class="dss-checkbox dss-checkbox-default dss-checkbox-normal"
                type="checkbox"
                name="default-normal "
                id="default-normal "
                checked=" "
              />
              <label
                for="default-normal "
                class="dss-checkbox-label dss-checkbox-label-normal dss-checkbox-label-default "
              >
                Check box label
              </label>
            </div>
          </div>
          <div class="dss-custom-checkbox  ">
            <div class="dss-checkbox-wrapper">
              <input
                class="dss-checkbox dss-checkbox-default dss-checkbox-small"
                type="checkbox"
                name="default-small "
                id="default-small "
                checked=" "
              />
              <label
                for="default-small "
                class="dss-checkbox-label dss-checkbox-label-small dss-checkbox-label-default "
              >
                Check box label
              </label>
            </div>
          </div>
          <div class="dss-custom-checkbox  disabled ">
            <div class="dss-checkbox-wrapper">
              <input
                class="dss-checkbox dss-checkbox-default dss-checkbox-normal"
                type="checkbox"
                name="default-normal "
                id="default-normal "
                checked=" "
                disabled
              />
              <label
                for="default-normal "
                class="dss-checkbox-label dss-checkbox-label-normal dss-checkbox-label-default "
              >
                Check box label
              </label>
            </div>
          </div>
          <div class="dss-custom-checkbox  disabled ">
            <div class="dss-checkbox-wrapper">
              <input
                class="dss-checkbox dss-checkbox-default dss-checkbox-small"
                type="checkbox"
                name="default-small "
                id="default-small "
                checked=" "
                disabled
              />
              <label
                for="default-small "
                class="dss-checkbox-label dss-checkbox-label-small dss-checkbox-label-default "
              >
                Check box label
              </label>
            </div>
          </div>
          <div class="dss-custom-checkbox  ">
            <div class="dss-checkbox-wrapper">
              <input
                class="dss-checkbox dss-checkbox-outline dss-checkbox-normal"
                type="checkbox"
                name="outline-normal "
                id="outline-normal "
                checked=" "
              />
              <label
                for="outline-normal "
                class="dss-checkbox-label dss-checkbox-label-normal dss-checkbox-label-outline "
              >
                Check box label
              </label>
            </div>
          </div>
          <div class="dss-custom-checkbox  ">
            <div class="dss-checkbox-wrapper">
              <input
                class="dss-checkbox dss-checkbox-outline dss-checkbox-small"
                type="checkbox"
                name="outline-small "
                id="outline-small "
                checked=" "
              />
              <label
                for="outline-small "
                class="dss-checkbox-label dss-checkbox-label-small dss-checkbox-label-outline "
              >
                Check box label
              </label>
            </div>
          </div>
          <div class="dss-custom-checkbox  disabled ">
            <div class="dss-checkbox-wrapper">
              <input
                class="dss-checkbox dss-checkbox-outline dss-checkbox-normal"
                type="checkbox"
                name="outline-normal "
                id="outline-normal "
                checked=" "
                disabled
              />
              <label
                for="outline-normal "
                class="dss-checkbox-label dss-checkbox-label-normal dss-checkbox-label-outline "
              >
                Check box label
              </label>
            </div>
          </div>
          <div class="dss-custom-checkbox  disabled ">
            <div class="dss-checkbox-wrapper">
              <input
                class="dss-checkbox dss-checkbox-outline dss-checkbox-small"
                type="checkbox"
                name="outline-small "
                id="outline-small "
                checked=" "
                disabled
              />
              <label
                for="outline-small "
                class="dss-checkbox-label dss-checkbox-label-small dss-checkbox-label-outline "
              >
                Check box label
              </label>
            </div>
          </div>
          {/* BUTTON */}
          <button class="dss-btn dss-btn-primary dss-btn-lg    " type="button">
            Button text
          </button>
          <button class="dss-btn dss-btn-primary dss-btn-md    " type="button">
            Button text
          </button>
          <button class="dss-btn dss-btn-primary dss-btn-sm    " type="button">
            Button text
          </button>
          <button
            class="dss-btn dss-btn-primary dss-btn-md   disabled "
            type="button"
          >
            Button text
          </button>
          <button
            class="dss-btn dss-btn-primary  dss-btn-fluid   "
            type="button"
          >
            Button text
          </button>
          <button
            class="dss-btn dss-btn-primary  dss-btn-fluid  disabled "
            type="button"
          >
            Button text
          </button>
          <button
            class="dss-btn dss-btn-secondary dss-btn-lg    "
            type="button"
          >
            Button text
          </button>
          <button
            class="dss-btn dss-btn-secondary dss-btn-md    "
            type="button"
          >
            Button text
          </button>
          <button
            class="dss-btn dss-btn-secondary dss-btn-sm    "
            type="button"
          >
            Button text
          </button>
          <button class="dss-btn dss-btn-secondary    disabled " type="button">
            Button text
          </button>
          <button class="dss-btn dss-btn-outlined dss-btn-lg    " type="button">
            Button text
          </button>
          <button class="dss-btn dss-btn-outlined dss-btn-md    " type="button">
            Button text
          </button>
          <button class="dss-btn dss-btn-outlined dss-btn-sm    " type="button">
            Button text
          </button>
          <button class="dss-btn dss-btn-outlined    disabled " type="button">
            Button text
          </button>
          <button class="dss-btn dss-btn-danger dss-btn-lg    " type="button">
            Button text
          </button>
          <button class="dss-btn dss-btn-danger dss-btn-md    " type="button">
            Button text
          </button>
          <button class="dss-btn dss-btn-danger dss-btn-sm    " type="button">
            Button text
          </button>
          <button class="dss-btn dss-btn-danger    disabled " type="button">
            Button text
          </button>
          <button class="dss-btn dss-btn-ghost dss-btn-lg    " type="button">
            Button text
          </button>
          <button class="dss-btn dss-btn-ghost dss-btn-md    " type="button">
            Button text
          </button>
          <button class="dss-btn dss-btn-ghost dss-btn-sm    " type="button">
            Button text
          </button>
          <button class="dss-btn dss-btn-ghost    disabled " type="button">
            Button text
          </button>
          <button class="dss-btn dss-btn-link dss-btn-lg    " type="button">
            Button text
          </button>
          <button class="dss-btn dss-btn-link dss-btn-md    " type="button">
            Button text
          </button>
          <button class="dss-btn dss-btn-link dss-btn-sm    " type="button">
            Button text
          </button>
          <button class="dss-btn dss-btn-link    disabled " type="button">
            Button text
          </button>
          <button
            class="dss-btn dss-btn-secondary dss-btn-lg dss-btn-icon"
            type="button"
          >
            <span class="dss-icon prefix-icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                color="#FFFFFF"
              >
                <rect
                  x="4.75"
                  y="4.75"
                  width="14.3581"
                  height="14.3581"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></rect>
                <path
                  d="M5.5 5.5L18.3615 18.3615"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
                <path
                  d="M18.3563 5.5L5.5 18.3563"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
              </svg>
            </span>
            Button text
            <span className="dss-icon suffix-icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                color="#FFFFFF"
              >
                <rect
                  x="4.75"
                  y="4.75"
                  width="14.3581"
                  height="14.3581"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></rect>
                <path
                  d="M5.5 5.5L18.3615 18.3615"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
                <path
                  d="M18.3563 5.5L5.5 18.3563"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
              </svg>
            </span>
          </button>
          <button
            class="dss-btn dss-btn-secondary dss-btn-icon disabled"
            type="button"
          >
            <span class="dss-icon prefix-icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                color="#FFFFFF"
              >
                <rect
                  x="4.75"
                  y="4.75"
                  width="14.3581"
                  height="14.3581"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></rect>
                <path
                  d="M5.5 5.5L18.3615 18.3615"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
                <path
                  d="M18.3563 5.5L5.5 18.3563"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
              </svg>
            </span>
            Button text
            <span className="dss-icon suffix-icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                color="#FFFFFF"
              >
                <rect
                  x="4.75"
                  y="4.75"
                  width="14.3581"
                  height="14.3581"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></rect>
                <path
                  d="M5.5 5.5L18.3615 18.3615"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
                <path
                  d="M18.3563 5.5L5.5 18.3563"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
              </svg>
            </span>
          </button>
          <button
            class="dss-btn dss-btn-primary dss-btn-md dss-btn-icon"
            type="button"
          >
            <span class="dss-icon prefix-icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                color="#FFFFFF"
              >
                <rect
                  x="4.75"
                  y="4.75"
                  width="14.3581"
                  height="14.3581"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></rect>
                <path
                  d="M5.5 5.5L18.3615 18.3615"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
                <path
                  d="M18.3563 5.5L5.5 18.3563"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
              </svg>
            </span>
            Button text
            <span className="dss-icon suffix-icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                color="#FFFFFF"
              >
                <rect
                  x="4.75"
                  y="4.75"
                  width="14.3581"
                  height="14.3581"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></rect>
                <path
                  d="M5.5 5.5L18.3615 18.3615"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
                <path
                  d="M18.3563 5.5L5.5 18.3563"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
              </svg>
            </span>
          </button>
          <button
            class="dss-btn dss-btn-primary dss-btn-icon disabled"
            type="button"
          >
            <span class="dss-icon prefix-icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                color="#FFFFFF"
              >
                <rect
                  x="4.75"
                  y="4.75"
                  width="14.3581"
                  height="14.3581"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></rect>
                <path
                  d="M5.5 5.5L18.3615 18.3615"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
                <path
                  d="M18.3563 5.5L5.5 18.3563"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
              </svg>
            </span>
            Button text
            <span className="dss-icon suffix-icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                color="#FFFFFF"
              >
                <rect
                  x="4.75"
                  y="4.75"
                  width="14.3581"
                  height="14.3581"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></rect>
                <path
                  d="M5.5 5.5L18.3615 18.3615"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
                <path
                  d="M18.3563 5.5L5.5 18.3563"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
              </svg>
            </span>
          </button>
          <button
            class="dss-btn dss-btn-primary dss-btn-lg dss-btn-icon icon-only"
            type="button"
          >
            <span class="dss-icon prefix-icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                color="#FFFFFF"
              >
                <rect
                  x="4.75"
                  y="4.75"
                  width="14.3581"
                  height="14.3581"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></rect>
                <path
                  d="M5.5 5.5L18.3615 18.3615"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
                <path
                  d="M18.3563 5.5L5.5 18.3563"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
              </svg>
            </span>
          </button>
          <button
            class="dss-btn dss-btn-primary dss-btn-sm dss-btn-icon icon-only"
            type="button"
          >
            <span class="dss-icon prefix-icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                color="#FFFFFF"
              >
                <rect
                  x="4.75"
                  y="4.75"
                  width="14.3581"
                  height="14.3581"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></rect>
                <path
                  d="M5.5 5.5L18.3615 18.3615"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
                <path
                  d="M18.3563 5.5L5.5 18.3563"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
              </svg>
            </span>
          </button>
          <button
            class="dss-btn dss-btn-primary dss-btn-icon disabled icon-only"
            type="button"
          >
            <span class="dss-icon prefix-icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                color="#FFFFFF"
              >
                <rect
                  x="4.75"
                  y="4.75"
                  width="14.3581"
                  height="14.3581"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></rect>
                <path
                  d="M5.5 5.5L18.3615 18.3615"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
                <path
                  d="M18.3563 5.5L5.5 18.3563"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
              </svg>
            </span>
          </button>
          <button
            class="dss-btn dss-btn-secondary dss-btn-sm dss-btn-icon icon-only"
            type="button"
          >
            <span class="dss-icon prefix-icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                color="#FFFFFF"
              >
                <rect
                  x="4.75"
                  y="4.75"
                  width="14.3581"
                  height="14.3581"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></rect>
                <path
                  d="M5.5 5.5L18.3615 18.3615"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
                <path
                  d="M18.3563 5.5L5.5 18.3563"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
              </svg>
            </span>
          </button>
          <button
            class="dss-btn dss-btn-secondary dss-btn-icon disabled icon-only"
            type="button"
          >
            <span class="dss-icon prefix-icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                color="#FFFFFF"
              >
                <rect
                  x="4.75"
                  y="4.75"
                  width="14.3581"
                  height="14.3581"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></rect>
                <path
                  d="M5.5 5.5L18.3615 18.3615"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
                <path
                  d="M18.3563 5.5L5.5 18.3563"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
              </svg>
            </span>
          </button>
          <button
            class="dss-btn dss-btn-outlined dss-btn-md dss-btn-icon icon-only"
            type="button"
          >
            <span class="dss-icon prefix-icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                color="#FFFFFF"
              >
                <rect
                  x="4.75"
                  y="4.75"
                  width="14.3581"
                  height="14.3581"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></rect>
                <path
                  d="M5.5 5.5L18.3615 18.3615"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
                <path
                  d="M18.3563 5.5L5.5 18.3563"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
              </svg>
            </span>
          </button>
          <button
            class="dss-btn dss-btn-outlined dss-btn-icon disabled icon-only"
            type="button"
          >
            <span class="dss-icon prefix-icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                color="#FFFFFF"
              >
                <rect
                  x="4.75"
                  y="4.75"
                  width="14.3581"
                  height="14.3581"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></rect>
                <path
                  d="M5.5 5.5L18.3615 18.3615"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
                <path
                  d="M18.3563 5.5L5.5 18.3563"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
              </svg>
            </span>
          </button>
          <button
            class="dss-btn dss-btn-danger dss-btn-lg dss-btn-icon icon-only"
            type="button"
          >
            <span class="dss-icon prefix-icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                color="#FFFFFF"
              >
                <rect
                  x="4.75"
                  y="4.75"
                  width="14.3581"
                  height="14.3581"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></rect>
                <path
                  d="M5.5 5.5L18.3615 18.3615"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
                <path
                  d="M18.3563 5.5L5.5 18.3563"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
              </svg>
            </span>
          </button>
          <button
            class="dss-btn dss-btn-danger dss-btn-icon disabled icon-only"
            type="button"
          >
            <span class="dss-icon prefix-icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                color="#FFFFFF"
              >
                <rect
                  x="4.75"
                  y="4.75"
                  width="14.3581"
                  height="14.3581"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></rect>
                <path
                  d="M5.5 5.5L18.3615 18.3615"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
                <path
                  d="M18.3563 5.5L5.5 18.3563"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
              </svg>
            </span>
          </button>
          <button
            class="dss-btn dss-btn-ghost dss-btn-lg dss-btn-icon icon-only"
            type="button"
          >
            <span class="dss-icon prefix-icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                color="#FFFFFF"
              >
                <rect
                  x="4.75"
                  y="4.75"
                  width="14.3581"
                  height="14.3581"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></rect>
                <path
                  d="M5.5 5.5L18.3615 18.3615"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
                <path
                  d="M18.3563 5.5L5.5 18.3563"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
              </svg>
            </span>
          </button>
          <button
            class="dss-btn dss-btn-ghost dss-btn-icon disabled icon-only"
            type="button"
          >
            <span class="dss-icon prefix-icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                color="#FFFFFF"
              >
                <rect
                  x="4.75"
                  y="4.75"
                  width="14.3581"
                  height="14.3581"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></rect>
                <path
                  d="M5.5 5.5L18.3615 18.3615"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
                <path
                  d="M18.3563 5.5L5.5 18.3563"
                  stroke="#FFFFFF"
                  stroke-width="1.5"
                ></path>
              </svg>
            </span>
          </button>

          <div class="dss-empty-state-box d-flex">
            <div class="dss-empty-state-img">
              <img
                src="data:image/png;base64,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"
                alt="guidelinesimage"
              />
            </div>
            <div class="dss-empty-state-content-wrapper">
              <div class="dss-empty-state-content">
                <p class="dss-empty-state-text dss-font-color-primary">
                  No alert configurations yet.
                </p>
                <span class="dss-empty-state-para d-block dss-font-color-tertiary">
                  Set a new one.
                </span>
              </div>
              <button
                class="dss-btn dss-btn-secondary dss-btn-md  dss-btn-icon   "
                type="button"
              >
                <span class="dss-icon prefix-icon undefined">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    color="#FFFFFF"
                  >
                    <rect
                      x="4.75"
                      y="4.75"
                      width="14.3581"
                      height="14.3581"
                      stroke="#FFFFFF"
                      stroke-width="1.5"
                    ></rect>
                    <path
                      d="M5.5 5.5L18.3615 18.3615"
                      stroke="#FFFFFF"
                      stroke-width="1.5"
                    ></path>
                    <path
                      d="M18.3563 5.5L5.5 18.3563"
                      stroke="#FFFFFF"
                      stroke-width="1.5"
                    ></path>
                  </svg>
                </span>
                Button text
                <span class="dss-icon suffix-icon undefined">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    color="#FFFFFF"
                  >
                    <rect
                      x="4.75"
                      y="4.75"
                      width="14.3581"
                      height="14.3581"
                      stroke="#FFFFFF"
                      stroke-width="1.5"
                    ></rect>
                    <path
                      d="M5.5 5.5L18.3615 18.3615"
                      stroke="#FFFFFF"
                      stroke-width="1.5"
                    ></path>
                    <path
                      d="M18.3563 5.5L5.5 18.3563"
                      stroke="#FFFFFF"
                      stroke-width="1.5"
                    ></path>
                  </svg>
                </span>
              </button>
            </div>
          </div>

          {/* INPUT */}

          <div class="dss-input-wrapper dss-input dss-input-wrapper dss-input">
            <div class="dss-input-label-wrapper">
              <label for="input" class="dss-input-label">
                Label
              </label>
              <div class="dss-input-container blur">
                <div class="dss-input-leading">
                  <span class="dss-input-icon">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      color="black"
                    >
                      <rect
                        x="4.75"
                        y="4.75"
                        width="14.3581"
                        height="14.3581"
                        stroke="black"
                        stroke-width="1.5"
                      ></rect>
                      <path
                        d="M5.5 5.5L18.3615 18.3615"
                        stroke="black"
                        stroke-width="1.5"
                      ></path>
                      <path
                        d="M18.3563 5.5L5.5 18.3563"
                        stroke="black"
                        stroke-width="1.5"
                      ></path>
                    </svg>
                  </span>
                  <p class="dss-prefix-text">Prefix</p>
                  <input
                    id="input"
                    type="text"
                    placeholder="value"
                    class="dss-input-field"
                    value=""
                  />
                </div>
                <div class="dss-input-trailing d-flex ml-auto">
                  <p class="dss-suffix-text">Suffix</p>
                  <span class="dss-input-icon">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      color="black"
                    >
                      <rect
                        x="4.75"
                        y="4.75"
                        width="14.3581"
                        height="14.3581"
                        stroke="black"
                        stroke-width="1.5"
                      ></rect>
                      <path
                        d="M5.5 5.5L18.3615 18.3615"
                        stroke="black"
                        stroke-width="1.5"
                      ></path>
                      <path
                        d="M18.3563 5.5L5.5 18.3563"
                        stroke="black"
                        stroke-width="1.5"
                      ></path>
                    </svg>
                  </span>
                </div>
              </div>
            </div>
            <div class="dss-error-container null">
              <span class="dss-error-icon">
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0.666504 5.99996C0.666504 3.05649 3.05584 0.666626 5.99984 0.666626C8.94917 0.666626 11.3332 3.05649 11.3332 5.99996C11.3332 8.94449 8.94917 11.3333 5.99984 11.3333C3.05584 11.3333 0.666504 8.94449 0.666504 5.99996ZM7.96681 7.96317C8.18862 7.7422 8.18862 7.3837 7.96681 7.16208L6.80555 6.00183L7.96681 4.84094C8.18862 4.61997 8.18862 4.25495 7.96681 4.03333C7.745 3.81106 7.38618 3.81106 7.15784 4.03333L6.0031 5.19292L4.84184 4.03333C4.6135 3.81106 4.25468 3.81106 4.03286 4.03333C3.81105 4.25495 3.81105 4.61997 4.03286 4.84094L5.19413 6.00183L4.03286 7.15556C3.81105 7.3837 3.81105 7.7422 4.03286 7.96317C4.14377 8.07398 4.29382 8.13329 4.43735 8.13329C4.5874 8.13329 4.73093 8.07398 4.84184 7.96317L6.0031 6.81009L7.16436 7.96317C7.27527 8.08115 7.4188 8.13329 7.56232 8.13329C7.71238 8.13329 7.8559 8.07398 7.96681 7.96317Z"
                    fill="#CE463D"
                  ></path>
                </svg>
              </span>
              <h6 class="dss-error-message">Helpful validation message</h6>
            </div>
          </div>

          <h4>INPUT-tag</h4>
         

					<div class="dss-input-wrapper dss-input dss-input-wrapper dss-input">
    <div class="dss-input-label-wrapper">
        <label for="input" class="dss-input-label">Label</label>
        <div class="dss-input-container blur">
            <div class="dss-input-leading">
            <span class="dss-input-icon">
            <svg
width="24"
height="24"
viewBox="0 0 24 24"
fill="none"
xmlns="http://www.w3.org/2000/svg"
color="black"
>
<rect
  x="4.75"
  y="4.75"
  width="14.3581"
  height="14.3581"
  stroke="black"
  stroke-width="1.5"
></rect>
<path d="M5.5 5.5L18.3615 18.3615" stroke="black" stroke-width="1.5"></path>
<path d="M18.3563 5.5L5.5 18.3563" stroke="black" stroke-width="1.5"></path>
</svg></span>
             <p class="dss-prefix-text">Prefix</p>
             <div class="dss-tag dss-tag-spacing-labelCloseicon">
    <div class="dss-tag-leading">
        <span class="dss-prefix-icon">
        <svg
width="24"
height="24"
viewBox="0 0 24 24"
fill="none"
xmlns="http://www.w3.org/2000/svg"
color="black"
>
<rect
  x="4.75"
  y="4.75"
  width="14.3581"
  height="14.3581"
  stroke="black"
  stroke-width="1.5"
></rect>
<path d="M5.5 5.5L18.3615 18.3615" stroke="black" stroke-width="1.5"></path>
<path d="M18.3563 5.5L5.5 18.3563" stroke="black" stroke-width="1.5"></path>
</svg></span>
</div>
    <span class="dss-tag-label">Basic tag</span>
     <span class="dss-close-icon">
    <svg
  width="8"
  height="8"
  viewBox="0 0 8 8"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M6.66484 1.33667L1.33855 6.6612"
    stroke="#434343"
    stroke-width="1.5"
    stroke-linecap="round"
  ></path>
  <path
    d="M6.66666 6.66671L1.33333 1.33337"
    stroke="#434343"
    stroke-width="1.5"
    stroke-linecap="round"
  ></path>
</svg></span>
</div>
                <input id="input" type="text" placeholder="value" class="dss-input-field" value="" />
            </div>
            <div class="dss-input-trailing d-flex ml-auto">
                <p class="dss-suffix-text">Suffix</p>
             <span class="dss-input-icon"><svg
width="24"
height="24"
viewBox="0 0 24 24"
fill="none"
xmlns="http://www.w3.org/2000/svg"
color="black"
>
<rect
  x="4.75"
  y="4.75"
  width="14.3581"
  height="14.3581"
  stroke="black"
  stroke-width="1.5"
></rect>
<path d="M5.5 5.5L18.3615 18.3615" stroke="black" stroke-width="1.5"></path>
<path d="M18.3563 5.5L5.5 18.3563" stroke="black" stroke-width="1.5"></path>
</svg></span>
            </div>
        </div>
    </div>
    <div class="dss-error-container null">
        <span class="dss-error-icon"><svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.666504 5.99996C0.666504 3.05649 3.05584 0.666626 5.99984 0.666626C8.94917 0.666626 11.3332 3.05649 11.3332 5.99996C11.3332 8.94449 8.94917 11.3333 5.99984 11.3333C3.05584 11.3333 0.666504 8.94449 0.666504 5.99996ZM7.96681 7.96317C8.18862 7.7422 8.18862 7.3837 7.96681 7.16208L6.80555 6.00183L7.96681 4.84094C8.18862 4.61997 8.18862 4.25495 7.96681 4.03333C7.745 3.81106 7.38618 3.81106 7.15784 4.03333L6.0031 5.19292L4.84184 4.03333C4.6135 3.81106 4.25468 3.81106 4.03286 4.03333C3.81105 4.25495 3.81105 4.61997 4.03286 4.84094L5.19413 6.00183L4.03286 7.15556C3.81105 7.3837 3.81105 7.7422 4.03286 7.96317C4.14377 8.07398 4.29382 8.13329 4.43735 8.13329C4.5874 8.13329 4.73093 8.07398 4.84184 7.96317L6.0031 6.81009L7.16436 7.96317C7.27527 8.08115 7.4188 8.13329 7.56232 8.13329C7.71238 8.13329 7.8559 8.07398 7.96681 7.96317Z"
          fill="#CE463D"></path></svg>
        </span>
        <h6 class="dss-error-message">Helpful validation message</h6>
    </div>
</div>

          <h4>INPUT - Disabled </h4>
          <div class="dss-input-wrapper dss-input dss-input-wrapper dss-input disabled">
    <div class="dss-input-label-wrapper">
        <label for="input" class="dss-input-label">Label</label>
        <div class="dss-input-container blur">
            <div class="dss-input-leading">
            <span class="dss-input-icon">
            <svg
width="24"
height="24"
viewBox="0 0 24 24"
fill="none"
xmlns="http://www.w3.org/2000/svg"
color="black"
>
<rect
  x="4.75"
  y="4.75"
  width="14.3581"
  height="14.3581"
  stroke="black"
  stroke-width="1.5"
></rect>
<path d="M5.5 5.5L18.3615 18.3615" stroke="black" stroke-width="1.5"></path>
<path d="M18.3563 5.5L5.5 18.3563" stroke="black" stroke-width="1.5"></path>
</svg></span>
             <p class="dss-prefix-text">Prefix</p>
             <div class="dss-tag dss-tag-spacing-labelCloseicon disabled">
    <div class="dss-tag-leading">
        <span class="dss-prefix-icon">
        <svg
width="24"
height="24"
viewBox="0 0 24 24"
fill="none"
xmlns="http://www.w3.org/2000/svg"
color="black"
>
<rect
  x="4.75"
  y="4.75"
  width="14.3581"
  height="14.3581"
  stroke="black"
  stroke-width="1.5"
></rect>
<path d="M5.5 5.5L18.3615 18.3615" stroke="black" stroke-width="1.5"></path>
<path d="M18.3563 5.5L5.5 18.3563" stroke="black" stroke-width="1.5"></path>
</svg></span>
</div>
    <span class="dss-tag-label">Basic tag</span>
     <span class="dss-close-icon">
    <svg
  width="8"
  height="8"
  viewBox="0 0 8 8"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M6.66484 1.33667L1.33855 6.6612"
    stroke="#434343"
    stroke-width="1.5"
    stroke-linecap="round"
  ></path>
  <path
    d="M6.66666 6.66671L1.33333 1.33337"
    stroke="#434343"
    stroke-width="1.5"
    stroke-linecap="round"
  ></path>
</svg></span>
</div>
                <input id="input" type="text" placeholder="value" class="dss-input-field" value="" />
            </div>
            <div class="dss-input-trailing d-flex ml-auto">
                <p class="dss-suffix-text">Suffix</p>
             <span class="dss-input-icon"><svg
width="24"
height="24"
viewBox="0 0 24 24"
fill="none"
xmlns="http://www.w3.org/2000/svg"
color="black"
>
<rect
  x="4.75"
  y="4.75"
  width="14.3581"
  height="14.3581"
  stroke="black"
  stroke-width="1.5"
></rect>
<path d="M5.5 5.5L18.3615 18.3615" stroke="black" stroke-width="1.5"></path>
<path d="M18.3563 5.5L5.5 18.3563" stroke="black" stroke-width="1.5"></path>
</svg></span>
            </div>
        </div>
    </div>
    <div class="dss-error-container null">
        <span class="dss-error-icon"><svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.666504 5.99996C0.666504 3.05649 3.05584 0.666626 5.99984 0.666626C8.94917 0.666626 11.3332 3.05649 11.3332 5.99996C11.3332 8.94449 8.94917 11.3333 5.99984 11.3333C3.05584 11.3333 0.666504 8.94449 0.666504 5.99996ZM7.96681 7.96317C8.18862 7.7422 8.18862 7.3837 7.96681 7.16208L6.80555 6.00183L7.96681 4.84094C8.18862 4.61997 8.18862 4.25495 7.96681 4.03333C7.745 3.81106 7.38618 3.81106 7.15784 4.03333L6.0031 5.19292L4.84184 4.03333C4.6135 3.81106 4.25468 3.81106 4.03286 4.03333C3.81105 4.25495 3.81105 4.61997 4.03286 4.84094L5.19413 6.00183L4.03286 7.15556C3.81105 7.3837 3.81105 7.7422 4.03286 7.96317C4.14377 8.07398 4.29382 8.13329 4.43735 8.13329C4.5874 8.13329 4.73093 8.07398 4.84184 7.96317L6.0031 6.81009L7.16436 7.96317C7.27527 8.08115 7.4188 8.13329 7.56232 8.13329C7.71238 8.13329 7.8559 8.07398 7.96681 7.96317Z"
          fill="#CE463D"></path></svg>
        </span>
        <h6 class="dss-error-message">Helpful validation message</h6>
    </div>
</div>

          <h4>INPUT - Readonly</h4>
          <div class="dss-input-wrapper dss-input dss-input-wrapper dss-input read-only">
    <div class="dss-input-label-wrapper">
        <label for="input" class="dss-input-label">Label</label>
        <div class="dss-input-container blur">
            <div class="dss-input-leading">
            <span class="dss-input-icon">
            <svg
width="24"
height="24"
viewBox="0 0 24 24"
fill="none"
xmlns="http://www.w3.org/2000/svg"
color="black"
>
<rect
  x="4.75"
  y="4.75"
  width="14.3581"
  height="14.3581"
  stroke="black"
  stroke-width="1.5"
></rect>
<path d="M5.5 5.5L18.3615 18.3615" stroke="black" stroke-width="1.5"></path>
<path d="M18.3563 5.5L5.5 18.3563" stroke="black" stroke-width="1.5"></path>
</svg></span>
             <p class="dss-prefix-text">Prefix</p>
             <div class="dss-tag dss-tag-spacing-labelCloseicon">
    <div class="dss-tag-leading">
        <span class="dss-prefix-icon">
        <svg
width="24"
height="24"
viewBox="0 0 24 24"
fill="none"
xmlns="http://www.w3.org/2000/svg"
color="black"
>
<rect
  x="4.75"
  y="4.75"
  width="14.3581"
  height="14.3581"
  stroke="black"
  stroke-width="1.5"
></rect>
<path d="M5.5 5.5L18.3615 18.3615" stroke="black" stroke-width="1.5"></path>
<path d="M18.3563 5.5L5.5 18.3563" stroke="black" stroke-width="1.5"></path>
</svg></span>
</div>
    <span class="dss-tag-label">Basic tag</span>
     <span class="dss-close-icon">
    <svg
  width="8"
  height="8"
  viewBox="0 0 8 8"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M6.66484 1.33667L1.33855 6.6612"
    stroke="#434343"
    stroke-width="1.5"
    stroke-linecap="round"
  ></path>
  <path
    d="M6.66666 6.66671L1.33333 1.33337"
    stroke="#434343"
    stroke-width="1.5"
    stroke-linecap="round"
  ></path>
</svg></span>
</div>
                <input id="input" type="text" placeholder="value" class="dss-input-field" value="" />
            </div>
            <div class="dss-input-trailing d-flex ml-auto">
                <p class="dss-suffix-text">Suffix</p>
             <span class="dss-input-icon"><svg
width="24"
height="24"
viewBox="0 0 24 24"
fill="none"
xmlns="http://www.w3.org/2000/svg"
color="black"
>
<rect
  x="4.75"
  y="4.75"
  width="14.3581"
  height="14.3581"
  stroke="black"
  stroke-width="1.5"
></rect>
<path d="M5.5 5.5L18.3615 18.3615" stroke="black" stroke-width="1.5"></path>
<path d="M18.3563 5.5L5.5 18.3563" stroke="black" stroke-width="1.5"></path>
</svg></span>
            </div>
        </div>
    </div>
    <div class="dss-error-container null">
        <span class="dss-error-icon"><svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.666504 5.99996C0.666504 3.05649 3.05584 0.666626 5.99984 0.666626C8.94917 0.666626 11.3332 3.05649 11.3332 5.99996C11.3332 8.94449 8.94917 11.3333 5.99984 11.3333C3.05584 11.3333 0.666504 8.94449 0.666504 5.99996ZM7.96681 7.96317C8.18862 7.7422 8.18862 7.3837 7.96681 7.16208L6.80555 6.00183L7.96681 4.84094C8.18862 4.61997 8.18862 4.25495 7.96681 4.03333C7.745 3.81106 7.38618 3.81106 7.15784 4.03333L6.0031 5.19292L4.84184 4.03333C4.6135 3.81106 4.25468 3.81106 4.03286 4.03333C3.81105 4.25495 3.81105 4.61997 4.03286 4.84094L5.19413 6.00183L4.03286 7.15556C3.81105 7.3837 3.81105 7.7422 4.03286 7.96317C4.14377 8.07398 4.29382 8.13329 4.43735 8.13329C4.5874 8.13329 4.73093 8.07398 4.84184 7.96317L6.0031 6.81009L7.16436 7.96317C7.27527 8.08115 7.4188 8.13329 7.56232 8.13329C7.71238 8.13329 7.8559 8.07398 7.96681 7.96317Z"
          fill="#CE463D"></path></svg>
        </span>
        <h6 class="dss-error-message">Helpful validation message</h6>
    </div>
</div>

          <h4>INPUT - fluid</h4>
          <div class="dss-input-wrapper dss-input dss-input-wrapper dss-input dss-input-fluid">
    <div class="dss-input-label-wrapper">
        <label for="input" class="dss-input-label">Label</label>
        <div class="dss-input-container blur">
            <div class="dss-input-leading">
                <input id="input" type="text" placeholder="value" class="dss-input-field" value="" />
            </div>
            <div class="dss-input-trailing d-flex ml-auto">
            </div>
        </div>
    </div>
    <div class="dss-error-container null">
        <span class="dss-error-icon"><svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.666504 5.99996C0.666504 3.05649 3.05584 0.666626 5.99984 0.666626C8.94917 0.666626 11.3332 3.05649 11.3332 5.99996C11.3332 8.94449 8.94917 11.3333 5.99984 11.3333C3.05584 11.3333 0.666504 8.94449 0.666504 5.99996ZM7.96681 7.96317C8.18862 7.7422 8.18862 7.3837 7.96681 7.16208L6.80555 6.00183L7.96681 4.84094C8.18862 4.61997 8.18862 4.25495 7.96681 4.03333C7.745 3.81106 7.38618 3.81106 7.15784 4.03333L6.0031 5.19292L4.84184 4.03333C4.6135 3.81106 4.25468 3.81106 4.03286 4.03333C3.81105 4.25495 3.81105 4.61997 4.03286 4.84094L5.19413 6.00183L4.03286 7.15556C3.81105 7.3837 3.81105 7.7422 4.03286 7.96317C4.14377 8.07398 4.29382 8.13329 4.43735 8.13329C4.5874 8.13329 4.73093 8.07398 4.84184 7.96317L6.0031 6.81009L7.16436 7.96317C7.27527 8.08115 7.4188 8.13329 7.56232 8.13329C7.71238 8.13329 7.8559 8.07398 7.96681 7.96317Z"
          fill="#CE463D"></path></svg>
        </span>
        <h6 class="dss-error-message">Helpful validation message</h6>
    </div>
</div>

          <h4>INPUT - Readonly</h4>
          {/* INPUT */}

          {/* MODAL HEADER  */}
          <div class="dss-modal-content">
            <div class="dss-modal-header" style={{ borderBottom: "0px" }}>
              <div class="dss-modal-header-leading">
                <span class="dss-modal-header-icon prefix-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    color="var(--dss-color-icon-modal-primary)"
                  >
                    <rect
                      x="4.75"
                      y="4.75"
                      width="14.3581"
                      height="14.3581"
                      stroke="var(--dss-color-icon-modal-primary)"
                      stroke-width="1.5"
                    ></rect>
                    <path
                      d="M5.5 5.5L18.3615 18.3615"
                      stroke="var(--dss-color-icon-modal-primary)"
                      stroke-width="1.5"
                    ></path>
                    <path
                      d="M18.3563 5.5L5.5 18.3563"
                      stroke="var(--dss-color-icon-modal-primary)"
                      stroke-width="1.5"
                    ></path>
                  </svg>
                </span>
                <h5 class="dss-modal-header-title dss-font-color-primary">
                  Title text
                </h5>
              </div>
              <span class="dss-modal-close-icon dss-iconbtn">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.3298 2.67285L2.67725 13.3219"
                    stroke="#171717"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  ></path>
                  <path
                    d="M13.3332 13.3337L2.6665 2.66699"
                    stroke="#171717"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  ></path>
                </svg>
              </span>
            </div>
          </div>
          {/* MODAL BODY  */}
          <div class="dss-modal-body">
            <div class="dss-modal-body-content">
              <div class="dss-preview dss-font-color-primary">modal-body</div>
            </div>
          </div>
          {/* MODAL FOOTER  */}
          <div
            class="dss-modal-footer"
            style={{ borderTop: "10px", width: "100%" }}
          >
            <button class="dss-btn dss-btn-secondary dss-btn-md" type="button">
              Cancel
            </button>
            <button class="dss-btn dss-btn-primary dss-btn-md" type="button">
              Apply
            </button>
          </div>
          {/* pagination */}
          <div class="dss-pagination">
            <ul class="pagination d-flex">
              <li class="pagination-list pagination-list-icon pagination-list-disabled">
                <span class="pagination-list-item">
                  <svg
                    width="8"
                    height="12"
                    viewBox="0 0 8 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.33331 10.6667L1.66665 6.00004L6.33331 1.33337"
                      stroke="#6D6D6D"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                </span>
              </li>
              <li class="pagination-list">
                <span class="pagination-list-item">1</span>
              </li>
              <li class="pagination-list">
                <span class="pagination-list-item active">2</span>
              </li>
              <li class="pagination-list">
                <span class="pagination-list-item">3</span>
              </li>
              <li class="pagination-list">
                <span class="pagination-list-item">4</span>
              </li>
              <li class="pagination-list">
                <span class="pagination-list-item">5</span>
              </li>
              <li class="pagination-list">
                <span class="pagination-list-item">...</span>
              </li>
              <li class="pagination-list">
                <span class="pagination-list-item">10</span>
              </li>
              <li class="pagination-list pagination-list-icon">
                <span class="pagination-list-item">
                  <svg
                    width="8"
                    height="12"
                    viewBox="0 0 8 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.66669 1.33329L6.33335 5.99996L1.66669 10.6666"
                      stroke="#171717"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                </span>
              </li>
            </ul>
          </div>
          {/* radio--button  */}
          <div class="dss-custom-radio-group dss-custom-radio-group-md">
            <label class="dss-radio-wrapper checked dss-radio-default    ">
              <input
                class="dss-radio-input"
                type="radio"
                name="radioGroup-0"
                value="option1"
                checked=""
              />
            </label>
            <label class="dss-radio-wrapper dss-radio-default  ">
              <input
                class="dss-radio-input"
                type="radio"
                name="radioGroup-0"
                value="option2"
              />
            </label>
          </div>
          <div class="dss-custom-radio-group dss-custom-radio-group-md">
            <label class="dss-radio-wrapper checked dss-radio-default with-label  ">
              <input
                class="dss-radio-input"
                type="radio"
                name="radioGroup-0"
                value="option1"
                checked=""
              />
              <span class="dss-radio-label dss-radio-label-default">
                Option 1
              </span>
            </label>
            <label class="dss-radio-wrapper dss-radio-default  ">
              <input
                class="dss-radio-input"
                type="radio"
                name="radioGroup-0"
                value="option2"
              />
              <span class="dss-radio-label dss-radio-label-default">
                Option 2
              </span>
            </label>
          </div>
          <div class="dss-custom-radio-group dss-custom-radio-group-md">
            <label class="dss-radio-wrapper checked dss-radio-default with-label  disabled ">
              <input
                class="dss-radio-input"
                type="radio"
                name="radioGroup-0"
                value="option1"
                checked=""
              />
              <span class="dss-radio-label dss-radio-label-default">
                Option 1
              </span>
            </label>
            <label class="dss-radio-wrapper dss-radio-default  disabled ">
              <input
                class="dss-radio-input"
                type="radio"
                name="radioGroup-0"
                value="option2"
              />
              <span class="dss-radio-label dss-radio-label-default">
                Option 2
              </span>
            </label>
          </div>
          <div class="dss-custom-radio-group dss-custom-radio-group-xs">
            <label class="dss-radio-wrapper checked dss-radio-default    ">
              <input
                class="dss-radio-input"
                type="radio"
                name="radioGroup-0"
                value="option1"
                checked=""
              />
            </label>
            <label class="dss-radio-wrapper dss-radio-default  ">
              <input
                class="dss-radio-input"
                type="radio"
                name="radioGroup-0"
                value="option2"
              />
            </label>
          </div>
          <div class="dss-custom-radio-group dss-custom-radio-group-xs">
            <label class="dss-radio-wrapper checked dss-radio-default with-label  ">
              <input
                class="dss-radio-input"
                type="radio"
                name="radioGroup-0"
                value="option1"
                checked=""
              />
              <span class="dss-radio-label dss-radio-label-default">
                Option 1
              </span>
            </label>
            <label class="dss-radio-wrapper dss-radio-default  ">
              <input
                class="dss-radio-input"
                type="radio"
                name="radioGroup-0"
                value="option2"
              />
              <span class="dss-radio-label dss-radio-label-default">
                Option 2
              </span>
            </label>
          </div>
          <div class="dss-custom-radio-group dss-custom-radio-group-xs">
            <label class="dss-radio-wrapper checked dss-radio-default with-label  disabled ">
              <input
                class="dss-radio-input"
                type="radio"
                name="radioGroup-0"
                value="option1"
                checked=""
              />
              <span class="dss-radio-label dss-radio-label-default">
                Option 1
              </span>
            </label>
            <label class="dss-radio-wrapper dss-radio-default  disabled ">
              <input
                class="dss-radio-input"
                type="radio"
                name="radioGroup-0"
                value="option2"
              />
              <span class="dss-radio-label dss-radio-label-default">
                Option 2
              </span>
            </label>
          </div>
          <div class="dss-custom-radio-group dss-custom-radio-group-md">
            <label class="dss-radio-wrapper checked dss-radio-outlined    ">
              <input
                class="dss-radio-input"
                type="radio"
                name="radioGroup-0"
                value="option1"
                checked=""
              />
            </label>
            <label class="dss-radio-wrapper dss-radio-outlined  ">
              <input
                class="dss-radio-input"
                type="radio"
                name="radioGroup-0"
                value="option2"
              />
            </label>
          </div>
          <div class="dss-custom-radio-group dss-custom-radio-group-md">
            <label class="dss-radio-wrapper checked dss-radio-outlined with-label  ">
              <input
                class="dss-radio-input"
                type="radio"
                name="radioGroup-0"
                value="option1"
                checked=""
              />
              <span class="dss-radio-label dss-radio-label-outlined">
                Option 1
              </span>
            </label>
            <label class="dss-radio-wrapper dss-radio-outlined  ">
              <input
                class="dss-radio-input"
                type="radio"
                name="radioGroup-0"
                value="option2"
              />
              <span class="dss-radio-label dss-radio-label-outlined">
                Option 2
              </span>
            </label>
          </div>
          <div class="dss-custom-radio-group dss-custom-radio-group-md">
            <label class="dss-radio-wrapper checked dss-radio-outlined with-label  disabled ">
              <input
                class="dss-radio-input"
                type="radio"
                name="radioGroup-0"
                value="option1"
                checked=""
              />
              <span class="dss-radio-label dss-radio-label-outlined">
                Option 1
              </span>
            </label>
            <label class="dss-radio-wrapper dss-radio-outlined  disabled ">
              <input
                class="dss-radio-input"
                type="radio"
                name="radioGroup-0"
                value="option2"
              />
              <span class="dss-radio-label dss-radio-label-outlined">
                Option 2
              </span>
            </label>
          </div>
          <div class="dss-custom-radio-group dss-custom-radio-group-xs">
            <label class="dss-radio-wrapper checked dss-radio-outlined    ">
              <input
                class="dss-radio-input"
                type="radio"
                name="radioGroup-0"
                value="option1"
                checked=""
              />
            </label>
            <label class="dss-radio-wrapper dss-radio-outlined  ">
              <input
                class="dss-radio-input"
                type="radio"
                name="radioGroup-0"
                value="option2"
              />
            </label>
          </div>
          <div class="dss-custom-radio-group dss-custom-radio-group-xs">
            <label class="dss-radio-wrapper checked dss-radio-outlined with-label  ">
              <input
                class="dss-radio-input"
                type="radio"
                name="radioGroup-0"
                value="option1"
                checked=""
              />
              <span class="dss-radio-label dss-radio-label-outlined">
                Option 1
              </span>
            </label>
            <label class="dss-radio-wrapper dss-radio-outlined  ">
              <input
                class="dss-radio-input"
                type="radio"
                name="radioGroup-0"
                value="option2"
              />
              <span class="dss-radio-label dss-radio-label-outlined">
                Option 2
              </span>
            </label>
          </div>
          <div class="dss-custom-radio-group dss-custom-radio-group-xs">
            <label class="dss-radio-wrapper checked dss-radio-outlined with-label  disabled ">
              <input
                class="dss-radio-input"
                type="radio"
                name="radioGroup-0"
                value="option1"
                checked=""
              />
              <span class="dss-radio-label dss-radio-label-outlined">
                Option 1
              </span>
            </label>
            <label class="dss-radio-wrapper dss-radio-outlined  disabled ">
              <input
                class="dss-radio-input"
                type="radio"
                name="radioGroup-0"
                value="option2"
              />
              <span class="dss-radio-label dss-radio-label-outlined">
                Option 2
              </span>
            </label>
          </div>
          {/* table  */}
          <table class="dss-scale-table">
            <thead>
              <tr>
                <th class="dss-scale-table-header">Size preview</th>
                <th class="dss-scale-table-header">Size token</th>
                <th class="dss-scale-table-header">Size</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="dss-table-cell">128px</td>
                <td class="dss-table-cell">
                  <p class="">space-3200</p>
                </td>
                <td class="dss-table-cell">size-128</td>
              </tr>
              <tr>
                <td class="dss-table-cell">112px</td>
                <td class="dss-table-cell">
                  <p class="">space-2800</p>
                </td>
                <td class="dss-table-cell">size-112</td>
              </tr>
              <tr>
                <td class="dss-table-cell">96px</td>
                <td class="dss-table-cell">
                  <p class="">space-2400</p>
                </td>
                <td class="dss-table-cell">size-96</td>
              </tr>
              <tr>
                <td class="dss-table-cell">80px</td>
                <td class="dss-table-cell">
                  <p class="">space-2800</p>
                </td>
                <td class="dss-table-cell">size-80</td>
              </tr>
              <tr>
                <td class="dss-table-cell">64px</td>
                <td class="dss-table-cell">
                  <p class="">space-2000</p>
                </td>
                <td class="dss-table-cell">size-64</td>
              </tr>
              <tr>
                <td class="dss-table-cell">24px</td>
                <td class="dss-table-cell">
                  <p class="">space-600</p>
                </td>
                <td class="dss-table-cell">size-24</td>
              </tr>
            </tbody>
          </table>
          {/* tag/chip  */}

          {/* textarea  */}
          <div class="dss-textarea-wrapper dss-textarea      ">
            <div class="dss-textarea-label-wrapper">
              <label for="textarea" class="dss-textarea-label">
                Label
              </label>
              <div class="dss-textarea-container">
                <div class="textarea-tag-container">
                  <textarea
                    placeholder="value"
                    id="0"
                    class="dss-textarea-field"
                    spellcheck="false"
                  ></textarea>
                </div>
              </div>
            </div>
            <div class="dss-count-container">
              <h6 class="dss-count-text">Helper text</h6>
              <h6 class="dss-count-text">0/20</h6>
            </div>
          </div>
          {/* tab  */}
          <div class="dss-tab">
            <div class="dss-tab-header dss-tab-header-${variant}">
              <button class="dss-tab-btn active dss-tab-btn-${variant}">
                Tab title 1
              </button>
              <button class="dss-tab-btn dss-tab-btn-${variant}">
                Tab title 2
              </button>
              <button class="dss-tab-btn dss-tab-btn-${variant}">
                Tab title 3
              </button>
            </div>
            <div class="dss-tab-body">
              <div class="dss-font-color-primary dss-ui-text-md dis-pt-10">
                Content 1
              </div>
            </div>
          </div>
          {/* toggle */}
          <label class="dss-toggler dss-toggler-large">
            <div class="dss-toggler-elem">
              <input
                class="dss-toggler-toggler-input"
                type="checkbox"
                checked=""
              />
            </div>
          </label>
          <label class="dss-toggler dss-toggler-normal">
            <div class="dss-toggler-elem">
              <input
                class="dss-toggler-toggler-input"
                type="checkbox"
                checked=""
              />
            </div>
          </label>
          <label class="dss-toggler dss-toggler-normal">
            <div class="dss-toggler-elem">
              <input
                class="dss-toggler-toggler-input"
                type="checkbox"
                checked=""
                disabled
              />
            </div>
          </label>
          <label class="dss-toggler dss-toggler-large">
            <div class="dss-toggler-elem">
              <input
                class="dss-toggler-toggler-input"
                type="checkbox"
                checked=""
              />
            </div>
            <span class="dss-toggler-text dss-font-toggle-uitext-large">
              Toggle Text
            </span>
          </label>
          <label class="dss-toggler dss-toggler-normal">
            <div class="dss-toggler-elem">
              <input
                class="dss-toggler-toggler-input"
                type="checkbox"
                checked=""
              />
            </div>
            <span class="dss-toggler-text dss-font-toggle-uitext-normal">
              Toggle Text
            </span>
          </label>
          <label class="dss-toggler dss-toggler-normal">
            <div class="dss-toggler-elem">
              <input
                class="dss-toggler-toggler-input"
                type="checkbox"
                checked=""
                disabled
              />
            </div>
            <span class="dss-toggler-text dss-font-toggle-uitext-normal">
              Toggle Text
            </span>
          </label>
          {/* toaster  */}
          <div class="dss-toaster">
            <div class="dss-toaster-leading">
              <div class="dss-toaster-msg-container  ">
                <h6 class="dss-toaster-msg">Message</h6>
                <div class="dss-toaster-trailing"></div>
              </div>
            </div>
          </div>
          {/* tooltip  */}
          <div class="dss-tooltip-container dss-ui-text-md dss-font-color-primary">
  Hover this
    <div class="tooltip tooltip-top tooltip-arrow-none tooltip-with-label">
      <h6 class="tooltip-label">Label</h6>
      <h4 class="tooltip-text">This is tooltip</h4>
    </div>
  </div>
	<div class="dss-tooltip-container dss-ui-text-md dss-font-color-primary">
  Hover this
    <div class="tooltip tooltip-bottom tooltip-btm-lft tooltip-with-label">
      <h6 class="tooltip-label">Label</h6>
      <h4 class="tooltip-text">This is tooltip</h4>
    </div>
  </div>
	<div class="dss-tooltip-container dss-ui-text-md dss-font-color-primary">
  Hover this
    <div class="tooltip tooltip-top tooltip-top-center tooltip-with-label">
      <h6 class="tooltip-label">Label</h6>
      <h4 class="tooltip-text">This is tooltip</h4>
    </div>
  </div>
	<div class="dss-tooltip-container dss-ui-text-md dss-font-color-primary">
  Hover this
    <div class="tooltip tooltip-left tooltip-lft-btm tooltip-with-label">
      <h6 class="tooltip-label">Label</h6>
      <h4 class="tooltip-text">This is tooltip</h4>
    </div>
  </div>
	<div class="dss-tooltip-container dss-ui-text-md dss-font-color-primary">
  Hover this
    <div class="tooltip tooltip-bottom tooltip-btm-lft tooltip-with-label">
      <h6 class="tooltip-label">Label</h6>
      <h4 class="tooltip-text">In which case you can set them to truncate, which can still get quite lon</h4>
    </div>
  </div>
	<div class="dss-tooltip-container dss-ui-text-md dss-font-color-primary">
  Hover this
    <div class="tooltip tooltip-top tooltip-arrow-none tooltip-with-label tooltip-wrap">
      <h6 class="tooltip-label">Label</h6>
      <h4 class="tooltip-text">Tooltips shouldn’t really exceed one line, but sometimes it’s unavoidable</h4>
    </div>
  </div>
          {/* tags  */}
					<div class="dss-tag dss-tag-large dss-tag-spacing-label">
    <span class="dss-tag-label">Basic tag</span>
</div>
<div class="dss-tag dss-tag-large dss-tag-spacing-label">
    <span class="dss-tag-label">Basic tag</span>
   <span class="dss-tag-counter">| 0</span>
</div>
<div class="dss-tag dss-tag-large dss-tag-spacing-label">
    <div class="dss-tag-leading">
        <span class="dss-prefix-icon">
        <svg
width="24"
height="24"
viewBox="0 0 24 24"
fill="none"
xmlns="http://www.w3.org/2000/svg"
color="black"
>
<rect
  x="4.75"
  y="4.75"
  width="14.3581"
  height="14.3581"
  stroke="black"
  stroke-width="1.5"
></rect>
<path d="M5.5 5.5L18.3615 18.3615" stroke="black" stroke-width="1.5"></path>
<path d="M18.3563 5.5L5.5 18.3563" stroke="black" stroke-width="1.5"></path>
</svg></span>
</div>
    <span class="dss-tag-label">Basic tag</span>
   <span class="dss-tag-counter">| 0</span>
</div>
<div class="dss-tag dss-tag-large dss-tag-spacing-labelStatusicon">
    <div class="dss-tag-leading">
        <span class="dss-prefix-icon">
        <svg
  width="16"
  height="17"
  viewBox="0 0 16 17"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M8 0.5C3.58862 0.5 0 4.08862 0 8.5C0 12.9114 3.58862 16.5 8 16.5C12.4114 16.5 16 12.9114 16 8.5C16 4.08862 12.4114 0.5 8 0.5ZM12.0547 6.80469L7.72131 11.1379C7.59131 11.2679 7.42065 11.3334 7.25 11.3334C7.07935 11.3334 6.90869 11.2679 6.77869 11.1379L4.61206 8.97131C4.35132 8.71069 4.35132 8.28931 4.61206 8.02869C4.87268 7.76794 5.29395 7.76794 5.55469 8.02869L7.25 9.724L11.1121 5.86206C11.3727 5.60132 11.7939 5.60132 12.0547 5.86206C12.3153 6.12268 12.3153 6.54395 12.0547 6.80469Z"
    fill="#0F900F"
  ></path>
</svg></span>
</div>
    <span class="dss-tag-label">Basic tag</span>
   <span class="dss-tag-counter">| 0</span>
</div>
<div class="dss-tag dss-tag-large dss-tag-spacing-labelCloseicon disabled">
    <div class="dss-tag-leading">
        <span class="dss-prefix-icon">
        <svg
width="24"
height="24"
viewBox="0 0 24 24"
fill="none"
xmlns="http://www.w3.org/2000/svg"
color="black"
>
<rect
  x="4.75"
  y="4.75"
  width="14.3581"
  height="14.3581"
  stroke="black"
  stroke-width="1.5"
></rect>
<path d="M5.5 5.5L18.3615 18.3615" stroke="black" stroke-width="1.5"></path>
<path d="M18.3563 5.5L5.5 18.3563" stroke="black" stroke-width="1.5"></path>
</svg></span>
</div>
    <span class="dss-tag-label">Basic tag</span>
     <span class="dss-close-icon">
    <svg
  width="8"
  height="8"
  viewBox="0 0 8 8"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M6.66484 1.33667L1.33855 6.6612"
    stroke="#434343"
    stroke-width="1.5"
    stroke-linecap="round"
  ></path>
  <path
    d="M6.66666 6.66671L1.33333 1.33337"
    stroke="#434343"
    stroke-width="1.5"
    stroke-linecap="round"
  ></path>
</svg></span>
</div>
<div class="dss-tag dss-tag-normal dss-tag-spacing-label">
    <div class="dss-tag-leading">
        <span class="dss-prefix-icon">
        <svg
width="24"
height="24"
viewBox="0 0 24 24"
fill="none"
xmlns="http://www.w3.org/2000/svg"
color="black"
>
<rect
  x="4.75"
  y="4.75"
  width="14.3581"
  height="14.3581"
  stroke="black"
  stroke-width="1.5"
></rect>
<path d="M5.5 5.5L18.3615 18.3615" stroke="black" stroke-width="1.5"></path>
<path d="M18.3563 5.5L5.5 18.3563" stroke="black" stroke-width="1.5"></path>
</svg></span>
</div>
    <span class="dss-tag-label">Basic tag</span>
   <span class="dss-tag-counter">| 0</span>
</div>
<div class="dss-tag dss-tag-normal dss-tag-spacing-labelCloseicon disabled">
    <div class="dss-tag-leading">
        <span class="dss-prefix-icon">
        <svg
width="24"
height="24"
viewBox="0 0 24 24"
fill="none"
xmlns="http://www.w3.org/2000/svg"
color="black"
>
<rect
  x="4.75"
  y="4.75"
  width="14.3581"
  height="14.3581"
  stroke="black"
  stroke-width="1.5"
></rect>
<path d="M5.5 5.5L18.3615 18.3615" stroke="black" stroke-width="1.5"></path>
<path d="M18.3563 5.5L5.5 18.3563" stroke="black" stroke-width="1.5"></path>
</svg></span>
</div>
    <span class="dss-tag-label">Basic tag</span>
     <span class="dss-close-icon">
    <svg
  width="8"
  height="8"
  viewBox="0 0 8 8"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M6.66484 1.33667L1.33855 6.6612"
    stroke="#434343"
    stroke-width="1.5"
    stroke-linecap="round"
  ></path>
  <path
    d="M6.66666 6.66671L1.33333 1.33337"
    stroke="#434343"
    stroke-width="1.5"
    stroke-linecap="round"
  ></path>
</svg></span>
</div>
<div class="dss-tag dss-tag-positive dss-tag-normal dss-tag-spacing-label">
    <div class="dss-tag-leading">
        <span class="dss-prefix-icon">
        <svg
width="24"
height="24"
viewBox="0 0 24 24"
fill="none"
xmlns="http://www.w3.org/2000/svg"
color="black"
>
<rect
  x="4.75"
  y="4.75"
  width="14.3581"
  height="14.3581"
  stroke="black"
  stroke-width="1.5"
></rect>
<path d="M5.5 5.5L18.3615 18.3615" stroke="black" stroke-width="1.5"></path>
<path d="M18.3563 5.5L5.5 18.3563" stroke="black" stroke-width="1.5"></path>
</svg></span>
</div>
    <span class="dss-tag-label">Basic tag</span>
   <span class="dss-tag-counter">| 0</span>
</div>
<div class="dss-tag dss-tag-positive dss-tag-normal dss-tag-spacing-labelCloseicon">
    <div class="dss-tag-leading">
        <span class="dss-prefix-icon">
        <svg
width="24"
height="24"
viewBox="0 0 24 24"
fill="none"
xmlns="http://www.w3.org/2000/svg"
color="black"
>
<rect
  x="4.75"
  y="4.75"
  width="14.3581"
  height="14.3581"
  stroke="black"
  stroke-width="1.5"
></rect>
<path d="M5.5 5.5L18.3615 18.3615" stroke="black" stroke-width="1.5"></path>
<path d="M18.3563 5.5L5.5 18.3563" stroke="black" stroke-width="1.5"></path>
</svg></span>
</div>
    <span class="dss-tag-label">Basic tag</span>
     <span class="dss-close-icon">
    <svg
  width="8"
  height="8"
  viewBox="0 0 8 8"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M6.66484 1.33667L1.33855 6.6612"
    stroke="#434343"
    stroke-width="1.5"
    stroke-linecap="round"
  ></path>
  <path
    d="M6.66666 6.66671L1.33333 1.33337"
    stroke="#434343"
    stroke-width="1.5"
    stroke-linecap="round"
  ></path>
</svg></span>
</div>
<div class="dss-tag dss-tag-negative dss-tag-normal dss-tag-spacing-labelStatusicon">
    <div class="dss-tag-leading">
        <span class="dss-prefix-icon">
        <svg
  width="16"
  height="17"
  viewBox="0 0 16 17"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M8 0.5C3.58862 0.5 0 4.08862 0 8.5C0 12.9114 3.58862 16.5 8 16.5C12.4114 16.5 16 12.9114 16 8.5C16 4.08862 12.4114 0.5 8 0.5ZM12.0547 6.80469L7.72131 11.1379C7.59131 11.2679 7.42065 11.3334 7.25 11.3334C7.07935 11.3334 6.90869 11.2679 6.77869 11.1379L4.61206 8.97131C4.35132 8.71069 4.35132 8.28931 4.61206 8.02869C4.87268 7.76794 5.29395 7.76794 5.55469 8.02869L7.25 9.724L11.1121 5.86206C11.3727 5.60132 11.7939 5.60132 12.0547 5.86206C12.3153 6.12268 12.3153 6.54395 12.0547 6.80469Z"
    fill="#0F900F"
  ></path>
</svg></span>
</div>
    <span class="dss-tag-label">Basic tag</span>
   <span class="dss-tag-counter">| 0</span>
</div>
<div class="dss-tag dss-tag-negative dss-tag-normal dss-tag-spacing-labelCloseicon disabled">
    <div class="dss-tag-leading">
        <span class="dss-prefix-icon">
        <svg
width="24"
height="24"
viewBox="0 0 24 24"
fill="none"
xmlns="http://www.w3.org/2000/svg"
color="black"
>
<rect
  x="4.75"
  y="4.75"
  width="14.3581"
  height="14.3581"
  stroke="black"
  stroke-width="1.5"
></rect>
<path d="M5.5 5.5L18.3615 18.3615" stroke="black" stroke-width="1.5"></path>
<path d="M18.3563 5.5L5.5 18.3563" stroke="black" stroke-width="1.5"></path>
</svg></span>
</div>
    <span class="dss-tag-label">Basic tag</span>
     <span class="dss-close-icon">
    <svg
  width="8"
  height="8"
  viewBox="0 0 8 8"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M6.66484 1.33667L1.33855 6.6612"
    stroke="#434343"
    stroke-width="1.5"
    stroke-linecap="round"
  ></path>
  <path
    d="M6.66666 6.66671L1.33333 1.33337"
    stroke="#434343"
    stroke-width="1.5"
    stroke-linecap="round"
  ></path>
</svg></span>
</div>
          
         
        </div>
      </section>

      <footer>
        <div className="container">
          <div className="footer-sub d-flex flex-wrap justify-content-between">
            <div className="box-footer">
              <h2>Address:</h2>
              <p>
                Rua Rafael Bandeira, 328 - Centro, Florianópolis/SC 88015-450,
                Brasil
              </p>
            </div>
            <div className="box-footer text-center">
              <h2>Phone Number</h2>
              <p>(48) 99901-3620</p>
            </div>
            <div className="box-footer">
              <h2>Receive our news</h2>
              <form action="#" className="d-flex">
                <div className="footer-input">
                  <Inputs
                    leadingIcon={false}
                    tailingIcon={false}
                    prefix={false}
                    suffix={false}
                    tag={false}
                    readOnlyState={false}
                    disabled={false}
                    fluid={false}
                    className="dss-input-sm"
                    label="your mail"
                  />
                </div>
                <PrimaryButton
                  // className={`dss-btn dss-btn-secondary dss-btn-icon dss-btn-md`}
                  variant="secondary"
                  size="md"
                  icon={true}
                  prefixIcon={false}
                  suffixIcon={<ButtonIcon />}
                />
              </form>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PreviewPage;
